module.exports = __webpack_public_path__ + "static/media/Parking-Active.216194c0.svg";